import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import Admin from './pages/Admin';
import Login from './pages/Login';
import Page404 from './pages/Page404';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import CssBaseline from "@material-ui/core/CssBaseline/CssBaseline";
import { adminTheme } from "./pages/AdminTheme"
import ErrorBoundary from './common/error';
import { ThemeProvider } from "@material-ui/styles";
import MomentUtils from "@date-io/moment";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import moment from "moment";
import "moment/locale/de";

moment.locale('de')



function AdminWrapper(props) {
    const { classes, theme } = props; // example
    return (
        <ThemeProvider theme={adminTheme}>
            <CssBaseline /> {/* initialize css */}
            <ErrorBoundary>
                <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils} locale={'de'}>
                    <Admin />
                </MuiPickersUtilsProvider>

            </ErrorBoundary>

        </ThemeProvider>
    );
}

if (window.location.pathname === '/admin' || window.location.pathname === '/login') {
    ReactDOM.render(
        <BrowserRouter>
            <Switch>
                <Route path="/admin" exact component={AdminWrapper} />
                <Route path="/login" component={Login} />
                {/* <Route path="*" component={Page404} /> */}
            </Switch>
        </BrowserRouter>,
        document.getElementById('root')
    );
}
